import {Badge, Tabs} from 'antd';
import {checkPerm} from "../auth/sessionTools";
import {Outlet, useNavigate} from "react-router";

export const TabController = ({session, numTasks}) => {
    const navigate = useNavigate();
    const onTabClick = (key, event) => {
        console.log(key);
        switch (key) {
            case 'General':
                navigate('/general');
                break;
            case 'Tasks':
                navigate('/tasks');
                break;
            case 'Location':
                navigate('/location');
                break;
            case 'Admin':
                navigate('/admin')
                break;
            default:
        }
    };

    // const onTabClick = (key, e) => {
    //     console.log(`tab ${key}`);
    // }

    const items = [
        {
            key: 'General',
            label: 'General',
            children: <div />,
        },
        {
            key: 'Tasks',
            label: <Badge count={numTasks} offset={[8, 0]} size={'small'}>Tasks</Badge>,
            children: <div />
        },
        {
            key: 'Location',
            label: 'Location',
            children: <div />
        }
    ];

    if (checkPerm(session, "executive")) {
        items.push({
            key: 'Admin',
            label: 'Admin',
            children: <div />
        })
    }


    return <>
        <Tabs defaultActiveKey={"General"} items={items} onTabClick={onTabClick}/>
        <Outlet />
    </>
}